import React, { ReactNode } from 'react'
import { Link } from 'react-router'

function ConvertibleIdLink({
    convertible,
    children,
}: {
    convertible: { convertibleId: string; convertible?: { convertibleId: string } }
    children: ReactNode
}) {
    const c = convertible.convertible || convertible
    return <Link to={`/convertibles/${c.convertibleId}`}>{children}</Link>
}

export default ConvertibleIdLink
